module.exports = __webpack_public_path__ + "img/pr.bf970311.svg";